<template>
    <app-dashboard-tiles :title="title" :series="series" :legend-title="legendTitle" chart-classes="flex-1 h-40">
        <template v-slot:chart>
            <pie-chart :data="data" :options="options" />
        </template>
        <template v-slot:legendFooter>
            <slot name="legendFooter"></slot>
        </template>
        <template v-slot:icon>
            <slot name="icon"></slot>
        </template>
    </app-dashboard-tiles>
</template>
<script>
import { Pie } from 'vue-chartjs';
import AppDashboardTiles from '@/components/app-dashboard-tiles/AppDashboardTiles.vue';

const PieChart = {
    extends: Pie,
    props: ['chartData', 'options'],
};
export default {
    components: { AppDashboardTiles, PieChart },
    props: {
        title: { type: String, default: () => '' },
        legendTitle: { type: String, default: () => '' },
        series: { type: Array, default: () => [] },
        data: { type: Object, default: () => [] },
        options: {
            type: Object,
            default: () => ({
                responsive: true,
                maintainAspectRatio: false,
                plugins: {
                    legend: {
                        display: false,
                    },
                    datalabels: {
                        display: false,
                    },
                },
            }),
        },
    },
};
</script>
